import { useCallback } from "react";
import {
  applyActionCode,
  checkActionCode,
  confirmPasswordReset,
  createUserWithEmailAndPassword,
  EmailAuthProvider,
  getAuth as getAuthFirebase,
  GoogleAuthProvider,
  linkWithCredential,
  linkWithRedirect,
  onAuthStateChanged,
  ProviderId,
  reauthenticateWithCredential,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  signInWithRedirect,
  signOut,
  unlink,
  updateEmail,
  updatePassword,
  verifyPasswordResetCode
} from "firebase/auth";

const useFirebase = () => {
  const getAuth = useCallback(() => {
    let authFirebase = getAuthFirebase();
    // authFirebase.tenantId = process.env.REACT_APP_FIREBASE_AUTH_TENANT_ID;

    return authFirebase;
  }, []);

  return {
    getAuth,
    GoogleAuthProvider,
    EmailAuthProvider,
    onAuthStateChanged,
    signInWithEmailAndPassword,
    signInWithRedirect,
    signInWithPopup,
    applyActionCode,
    checkActionCode,
    confirmPasswordReset,
    verifyPasswordResetCode,
    sendPasswordResetEmail,
    linkWithRedirect,
    ProviderId,
    unlink,
    createUserWithEmailAndPassword,
    linkWithCredential,
    reauthenticateWithCredential,
    updateEmail,
    updatePassword,
    signOut
  };
};

export default useFirebase;
